import { render } from "./PaintingDetailView.vue?vue&type=template&id=ecdac280&scoped=true"
import script from "./PaintingDetailView.vue?vue&type=script&lang=js"
export * from "./PaintingDetailView.vue?vue&type=script&lang=js"

import "./PaintingDetailView.vue?vue&type=style&index=0&id=ecdac280&scoped=true&lang=css"

import exportComponent from "D:\\Code_projects\\maria_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecdac280"]])

export default __exports__